import { Joi, actionCreator, literalAs, objectSchemaOf } from '../helpers';
import { JOBS_INPUT } from './topics';

export const NEW_JOB = 'JOBS/NEW' as const;

export const newJobActionSchema = objectSchemaOf<INewJobAction>({
  type: Joi.string().required().valid(NEW_JOB),
});

export interface INewJobAction {
  type: typeof NEW_JOB;
}

export const newJob = actionCreator({
  schema: newJobActionSchema,
  topic: JOBS_INPUT,
  type: NEW_JOB,
  creator: () => literalAs<INewJobAction>({ type: NEW_JOB }),
});
